export default [
  {
    path: '/service-overview',
    name: 'service-overview',
    component: () => import('@/views/serviceOverview/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.serviceOverview',
      navActiveLink: 'service-overview',
      resource: 'manage-service-overview',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.serviceOverview',
          active: true,
        },
      ],
    },
  },
]
